/**
 * URL API du dashboard partenaire.
 *
 * Create React App injecte REACT_APP_* au moment du `npm run build` uniquement.
 * Sans `.env.production`, le build embarque localhost → en ligne les boîtes / lieux ne chargent
 * que si votre machine locale tourne.
 */
const DEFAULT_LOCAL_API = 'http://localhost:8000/api';
const DEFAULT_PRODUCTION_API = 'https://api26.sherlook.fr/api';

function isLocalBrowserHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

function resolveApiUrl(): string {
  const fromBuild = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (!isLocalBrowserHost(host)) {
      // Déployé sur un vrai domaine : ne jamais appeler localhost du poste de dev.
      if (!fromBuild || fromBuild.includes('localhost') || fromBuild.includes('127.0.0.1')) {
        return DEFAULT_PRODUCTION_API;
      }
      return fromBuild.endsWith('/api') ? fromBuild : `${fromBuild}/api`;
    }
  }

  return fromBuild || DEFAULT_LOCAL_API;
}

export const config = {
  apiUrl: resolveApiUrl(),
  port: process.env.PORT || 3002,
};
